// export const API_BASE_CMS = 'https://hadinsoft.com/hreplcmsweb';   // Drupal Api 
// export const API_BASE_IMG_URl = 'https://hadinsoft.com';   // Drupal Api 

//Uat url
// export const API_BASE_CMS = 'https://hreplcms.hgsinteractive.com';   // Drupal Api 
// export const API_BASE_IMG_URl = 'https://hreplcms.hgsinteractive.com';   // Drupal Api 

//Production url
export const API_BASE_CMS = 'https://cms.hindujarenewables.com';  
export const API_BASE_IMG_URl = 'https://cms.hindujarenewables.com'; 

